import React, { useState } from "react";
import axios from "axios";
import ButtonBlack from "../../../components/Buttons/ButtonBlack";
import Input from "../../../components/Form/Input";
import TextAreaEditor from "../../../components/Form/TextAreaEditor";
import { API_END_POINT } from "../../../utils/constant";
import image2 from "../../assets/Illustrations/contactus3.png"
import { useOutletContext } from "react-router-dom";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    email: "",
    subject: "",
    message: "",
  });
  // const [showNotif, setShowNotif] = useState({
  //   show: false,
  //   message:"Une erreur est survenue",
  //   variant: "danger"
  // })
      const {showNotif, setShowNotif} = useOutletContext()

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  // Fonction de validation
  const validateForm = () => {
    let newErrors = {};
    if (!formData.email.includes("@")) newErrors.email = "Email invalide.";
    if (!formData.subject.trim()) newErrors.subject = "L'objet est requis.";
    if (!formData.message.trim()) newErrors.message = "Le message est requis.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Fonction de gestion du changement des inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      // Vérifier localement si l'email est valide avant d'appeler l'API
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!emailRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "L'email n'est pas valide.",
        }));
        // return;
      }
    else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: null,
        }));
      }
 } 
}

  // Fonction d'envoi du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setSuccessMessage("");

    try {
      const response = await axios.post(API_END_POINT+"/contact", formData);
      // setSuccessMessage("Votre message a été envoyé avec succès !");
      setFormData({ email: "", subject: "", message: "" });
      setShowNotif({ ...showNotif, variant: "success", message: response?.data?.message, show: true });
      setErrors({});
    } catch (error) {
      setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
      console.log(error)
      // setErrors({ form: "Une erreur est survenue. Veuillez réessayer." });
    }

    setLoading(false);
  };

  return (
    <div>
      <div className="absolute  right-0 top-0 w-40 m-auto h-80 max-w-lg bg-gradient-to-tr from-[#e3ffb7] via-[#dafd87] to-primary-green blur-[118px]"></div>
      <div className="mx-auto my-14 lg:my-20 grid grid-cols-1 md:grid-cols-2 gap-6 lg:px-20 px-6 xl:px-40">
        {/* Texte d'information */}
        <div className="place-center flex flex-col ">
          <div className="space-y-10 text-start">
            <p className="text-lg font-bold">Nous Contacter</p>
            <h1 className="font-bold text-2xl lg:text-4xl">
              Nous sommes à <span className="ml-1 px-1 ">Votre Écoute</span>
            </h1>
            <p className="text-primary-text text-base lg:text-lg">
              Vous avez des questions ou besoin d’informations ? Contactez-nous via ce formulaire.
            </p>
          </div>
          <img src={image2} alt="jndkjg" className="w-[450px] " />
        </div>

        {/* Formulaire de contact */}
        <div className="flex items-center justify-center">
          <form onSubmit={handleSubmit} className="bg-white border p-6 rounded-md drop-shadow-md w-full h-fit">
            {errors.form && <p className="text-red-500">{errors.form}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <Input label="Email" name="email" value={formData.email} onChange={handleChange} error={errors.email}/>

            <Input label="Objet" name="subject" value={formData.subject} onChange={handleChange} error={errors.subject} />

            <TextAreaEditor label="Message" name="message" error={errors.message} value={formData.message}  setValue={(value)=>setFormData({...formData, message: value})} />

            <div className="flex my-6 justify-end">
              <ButtonBlack type="submit" disabled={loading}>
                {loading ? "Envoi en cours..." : "Envoyer"}
              </ButtonBlack>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;


// import React from 'react'
// // import img404 from "../../assets/images/404.png"
// import ButtonBlack from '../../../components/Buttons/ButtonBlack'
// // import ButtonHoverAnimated from '../../../components/Buttons/ButtonHoverAnimated'
// import Input from '../../../components/Form/Input'
// import TextAreaEditor from '../../../components/Form/TextAreaEditor'


// const ContactUs = () => {
  
//   return (
//     <div>
//         <div className=" mx-auto my-14 lg:my-20 grid grid-cols-1 md:grid-cols-2  gap-6 lg:px-20 px-6 xl:px-40 flex-col-reverse   ">
//             <div className=' place-center '>
//               <div className='space-y-10  text-start'>
//                 <p className='text-lg font-bold'>Nous Contacter</p>
//                 <h1 className='font-bold text-2xl lg:text-4xl'>Nous sommes à <span className="ml-1 px-1 bg-primary-green"> Votre Ecoute</span></h1>
//                 <p className='text-primary-text text-base lg:text-lg'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cum quod beatae, dicta recusandae quasi aperiam cupiditate ipsam, labore aliquam, laboriosam nemo assumenda harum vel. Quo iusto iste repudiandae sit eos.</p>
//                 <div className="w-full md:block hidden">
//                   <div className="bg-white border  rounded-md shadow p-2 w-full max-w-md flex justify-between">
//                     <input
//                       type="email"
//                       className="outline-none p-2 w-full"
//                       placeholder="Entrez votre email..."
//                     />
//                     <button className="bg-primary-black text-white px-4 py-2 rounded-sm">
//                       S'abonner
//                     </button>
//                   </div>
//                 </div>      
//                 </div>
//                 </div>
//                 <div className=" flex items-center justify-center">
//                   <div className="bg-white border p-6 rounded-md drop-shadow-md w-full h-fit">
//                     <Input label="Email"/>
//                     <Input label="Objet"/>
//                     <TextAreaEditor label='Message'/>
//                     <div className="flex my-6 justify-end">
//                     <ButtonBlack>Envoyer</ButtonBlack>
//                     </div>
//                   </div>
//                 </div>
//         </div>
//     </div>
//   )
// }

// export default ContactUs